import { useStore } from '@/contexts/StoreContext';
import { addonAtivo, type Addon } from '@/lib/addons';
import { PageNotFound } from '@/components/common/PageNotFound';

/**
 * A rota de um módulo, atrás do estado do addon.
 *
 * Location: src/components/common
 * Why: esconder o link não basta. O endereço do fórum já foi para o Discord,
 * para o histórico do navegador e para o índice do Google — desligar o módulo
 * sem tratar a rota deixaria a página tentando carregar dados que a API agora
 * recusa, e o visitante veria um erro em vez de uma resposta.
 *
 * Mostra "não encontrada", e não "desligado": para quem visita, um módulo que
 * o lojista desligou simplesmente não existe nesta loja. Contar que existe mas
 * está fora do ar é informação da operação dele, não do visitante.
 *
 * Isto é a aparência, não a tranca. A tranca é o `RequireAddon` na API, que
 * devolve 404 para a mesma rota chamada direto.
 */
export function AddonRoute({
  addon,
  children,
}: {
  addon: Addon;
  children: React.ReactNode;
}) {
  const { store } = useStore();

  if (!addonAtivo(store?.addons, addon)) {
    return <PageNotFound />;
  }

  return <>{children}</>;
}
